import React, { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

import BottomSheet from "../../app/BottomSheet";
import SearchInput from "src/components/app/SearchInput";
import Loader from "src/components/common/Loader";
import NoData from "src/components/app/NoData";

import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { getCitiesListRequest } from "src/redux/slices/locationSlice";
import { City } from "src/types/location.types";

interface CityBottomSheetProps {
  show: boolean;
  handleClose: () => void;
  onSelect: (city: City) => void;
  stateId: string;
}

const CityBottomSheet: React.FC<CityBottomSheetProps> = ({
  show,
  handleClose,
  onSelect,
  stateId,
}) => {
  const [searchText, setSearchText] = useState("");
  const dispatch = useAppDispatch();
  const { cities } = useAppSelector((state) => state.location);

  useEffect(() => {
    getCitiesList();
  }, []);

  useEffect(() => {
    // if (debouncedSearchText) {
    getCitiesList();
    // }
  }, [searchText]);

  const getCitiesList = () => {
    try {
      const payload = {
        state_id: stateId,
        search: searchText,
        // source: "Anyra Care Program",
      };
      dispatch(
        getCitiesListRequest({
          payload,
          resolve: () => {},
          reject: () => {},
        })
      );
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleSelect = (city: City) => {
    onSelect(city);
    handleClose();
  };

  return (
    <BottomSheet
      show={show}
      title="Select Doctor's City"
      handleClose={handleClose}
    >
      <div className="flex flex-col p-4 gap-4">
        <SearchInput
          name="city"
          label="City name"
          type="text"
          placeholder="Enter city name"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <div className="h-[300px] overflow-y-auto">
          {cities?.isLoading ? (
            <div className="flex justify-center items-center h-full">
              <Loader size="lg" color="primary" />
            </div>
          ) : cities?.data?.length > 0 ? (
            cities?.data?.map((city) => (
              <button
                key={city?.city_master_id}
                className="w-full px-4 py-2 hover:bg-gray-50 text-left text-md text-gray-700 border-b border-gray-200"
                onClick={() => handleSelect(city)}
              >
                {city?.city_name}
              </button>
            ))
          ) : cities?.data?.length === 0 && !cities?.isLoading ? (
            <NoData
              icon={<MapPin />}
              title="No cities found"
              className="pb-8"
            />
          ) : null}
        </div>
      </div>
    </BottomSheet>
  );
};

export default CityBottomSheet;
